import {
  FETCH_FABRICATION_JOBS,
  FETCH_FABRICATION_JOBS_SUCCESS,
  FETCH_FABRICATION_JOBS_FAILURE,
  CREATE_FABRICATION_JOB,
  CREATE_FABRICATION_JOB_SUCCESS,
  CREATE_FABRICATION_JOB_FAILURE,
  UPDATE_FABRICATION_JOB,
  UPDATE_FABRICATION_JOB_SUCCESS,
  UPDATE_FABRICATION_JOB_FAILURE,
  DELETE_FABRICATION_JOB,
  DELETE_FABRICATION_JOB_SUCCESS,
  DELETE_FABRICATION_JOB_FAILURE,
} from './types';

export const fetchFabricationJobs = (payload) => ({
  type: FETCH_FABRICATION_JOBS,
  ...payload,
});

export const fetchFabricationJobsSuccess = (payload) => ({
  type: FETCH_FABRICATION_JOBS_SUCCESS,
  ...payload,
});

export const fetchFabricationJobsFailure = () => ({
  type: FETCH_FABRICATION_JOBS_FAILURE,
});

export const createFabricationJob = (payload) => ({
  type: CREATE_FABRICATION_JOB,
  ...payload,
});

export const createFabricationJobSuccess = (payload) => ({
  type: CREATE_FABRICATION_JOB_SUCCESS,
  ...payload,
});

export const createFabricationJobFailure = () => ({
  type: CREATE_FABRICATION_JOB_FAILURE,
});

export const updateFabricationJob = (payload) => ({
  type: UPDATE_FABRICATION_JOB,
  ...payload,
});

export const updateFabricationJobSuccess = (payload) => ({
  type: UPDATE_FABRICATION_JOB_SUCCESS,
  ...payload,
});

export const updateFabricationJobFailure = () => ({
  type: UPDATE_FABRICATION_JOB_FAILURE,
});

export const deleteFabricationJob = (payload) => ({
  type: DELETE_FABRICATION_JOB,
  ...payload,
});

export const deleteFabricationJobSuccess = (payload) => ({
  type: DELETE_FABRICATION_JOB_SUCCESS,
  ...payload,
});

export const deleteFabricationJobFailure = () => ({
  type: DELETE_FABRICATION_JOB_FAILURE,
});
